module.exports = __webpack_public_path__ + "static/media/checkpointmagazinelogo.66e1468f.png";